import { useEffect, useState } from "react";
import { getConfig } from "../../config/config";
import { ensureConfig } from "../../services/configuration-service";
import type { TRegion } from "../../models/region-model";
import { AuthPresentational } from "./AuthPresentational";
import { DropdownProps } from "@fluentui/react-components";
import {
  bestGuessRegion,
  regionFromCode,
  regionFromNameContains,
  storeRegionInBrowser,
} from "../../services/localisation-service";

export interface Props {
  onAuthSuccess: () => void;
  openLoginDialog: () => Promise<void>;
}

export const AuthContainer = (props: Props) => {
  const [signUpUrl, setSignUpUrl] = useState("");
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState({ errorMessage: "" });
  const [region, setRegion] = useState<TRegion>(bestGuessRegion());

  const onRegionSelectionChanged: DropdownProps["onOptionSelect"] = async (_, data) => {
    const regionCode = data.optionValue as string;
    const region = regionFromCode(regionCode) || regionFromNameContains(regionCode);

    setRegion(region);

    console.info(`Selected region: ${region.code}`);
  };

  useEffect(() => {
    const config = ensureConfig();
    const regionConfig = getConfig(config.product, config.environment, region.code);

    console.info(`Setting sign-up url: ${region.code} | ${regionConfig.SignUpUrl}`);

    setSignUpUrl(regionConfig.SignUpUrl);
  }, [region]);

  const login = async () => {
    setInProgress(true);
    storeRegionInBrowser(region.code);

    try {
      await props.openLoginDialog();
      props.onAuthSuccess();
    } catch (e) {
      if (typeof e === "string") {
        setError({ errorMessage: e });
      } else {
        setError({ errorMessage: `${e}` });
      }
    } finally {
      setInProgress(false);
    }
  };

  return (
    <AuthPresentational
      region={region}
      signUpUrl={signUpUrl}
      inProgress={inProgress}
      error={error.errorMessage}
      handleLogin={login}
      onRegionSelectionChanged={onRegionSelectionChanged}
    />
  );
};
